import React from 'react';
import FeatureCard from './FeatureCard';
import { FiArrowRight, FiAward, FiFileText, FiHeadphones, FiLayers } from 'react-icons/fi';

export default function Features() {
  return (
    <section className="px-4 py-12 sm:px-6 lg:px-8 lg:py-14">
      <div className="mx-auto max-w-7xl">
        <div className="grid gap-7 lg:grid-cols-3">
          <div className="col-span-1 rounded-[1.8rem] border border-[#f6c7b4] bg-gradient-to-br from-[#fff1e8] via-[#fff7f2] to-white p-7 shadow-[0_28px_70px_-48px_rgba(242,100,63,0.8)]">
            <p className="text-xs font-semibold uppercase tracking-[0.14em] text-[var(--brand-accent)]">Why choose us</p>
            <h2 className="mt-4 text-3xl leading-tight text-[var(--brand-ink)]">Everything you need to manage your subscription in one place.</h2>
            <p className="mt-4 text-sm text-[var(--text-muted)]">Digitalbookshelfcare.com offers you a simple way to manage subscriptions, contact agents, and access support from partner-trained teams.</p>
            <div className="mt-7 inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-sm font-semibold text-[var(--brand-accent-strong)] shadow-[0_14px_24px_-18px_rgba(13,27,42,0.7)]">Reliable service <FiArrowRight className="h-4 w-4" /></div>
          </div>

          <div className="col-span-2 grid gap-5 md:grid-cols-2">
            <FeatureCard title="Simplified management of your subscriptions" icon={<FiLayers />} eyebrow="Management" className="md:col-span-2">
              Digitalbookshelfcare.com offers you to easily manage different subscriptions. Fill in the e-mail address you used when you subscribed and reach your customer account in one click.
            </FeatureCard>

            <FeatureCard title="All the essential information" icon={<FiFileText />} eyebrow="Control">
              All the essential information is there to give you maximum control of your subscriptions. You can also contact the agents to ask for help, unsubscribe or make a complaint.
            </FeatureCard>

            <FeatureCard title="Agents at your service" icon={<FiHeadphones />} eyebrow="Support">
              Our agents are experts in after-sales services and have all the answers to your questions. We work 7 days per week, so you can contact the agents by live chat or by phone.
            </FeatureCard>

            <FeatureCard title="Recognized expertise" icon={<FiAward />} eyebrow="Expertise" className="md:col-span-2">
              We provide the after-sales service of several partner sites, which are all satisfied with our services. Our expertise provides the support for every single client.
            </FeatureCard>
          </div>
        </div>
      </div>
    </section>
  );
}
